(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLogsPublicApi = void 0;
var browser_core_1 = require("@datadog/browser-core");
var configuration_1 = require("../domain/configuration");
var logger_1 = require("../domain/logger");
function makeLogsPublicApi(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0, browser_core_1.createContextManager)();
    var userContextManager = (0, browser_core_1.createContextManager)();
    var customLoggers = {};
    var getInternalContextStrategy = function () { return undefined; };
    var beforeInitLoggerLog = new browser_core_1.BoundedBuffer();
    var handleLogStrategy = function (logsMessage, logger, savedCommonContext, date) {
        if (savedCommonContext === void 0) { savedCommonContext = (0, browser_core_1.deepClone)(getCommonContext()); }
        if (date === void 0) { date = (0, browser_core_1.timeStampNow)(); }
        beforeInitLoggerLog.add(function () { return handleLogStrategy(logsMessage, logger, savedCommonContext, date); });
    };
    var getInitConfigurationStrategy = function () { return undefined; };
    var mainLogger = new logger_1.Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return handleLogStrategy.apply(void 0, params);
    });
    function getCommonContext() {
        return {
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
            context: globalContextManager.getContext(),
            user: userContextManager.getContext(),
        };
    }
    return (0, browser_core_1.makePublicApi)({
        logger: mainLogger,
        init: (0, browser_core_1.monitor)(function (initConfiguration) {
            var _a;
            if ((0, browser_core_1.canUseEventBridge)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            if (!canInitLogs(initConfiguration)) {
                return;
            }
            var configuration = (0, configuration_1.validateAndBuildLogsConfiguration)(initConfiguration);
            if (!configuration) {
                return;
            }
            ;
            (_a = startLogsImpl(initConfiguration, configuration, getCommonContext, mainLogger), handleLogStrategy = _a.handleLog, getInternalContextStrategy = _a.getInternalContext);
            getInitConfigurationStrategy = function () { return (0, browser_core_1.deepClone)(initConfiguration); };
            beforeInitLoggerLog.drain();
            isAlreadyInitialized = true;
        }),
        /** @deprecated: use getGlobalContext instead */
        getLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.get),
        getGlobalContext: (0, browser_core_1.monitor)(globalContextManager.getContext),
        /** @deprecated: use setGlobalContext instead */
        setLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.set),
        setGlobalContext: (0, browser_core_1.monitor)(globalContextManager.setContext),
        /** @deprecated: use setGlobalContextProperty instead */
        addLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.add),
        setGlobalContextProperty: (0, browser_core_1.monitor)(globalContextManager.setContextProperty),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeLoggerGlobalContext: (0, browser_core_1.monitor)(globalContextManager.remove),
        removeGlobalContextProperty: (0, browser_core_1.monitor)(globalContextManager.removeContextProperty),
        clearGlobalContext: (0, browser_core_1.monitor)(globalContextManager.clearContext),
        createLogger: (0, browser_core_1.monitor)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new logger_1.Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return handleLogStrategy.apply(void 0, params);
            }, name, conf.handler, conf.level, conf.context);
            return customLoggers[name];
        }),
        getLogger: (0, browser_core_1.monitor)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0, browser_core_1.monitor)(function () { return getInitConfigurationStrategy(); }),
        getInternalContext: (0, browser_core_1.monitor)(function (startTime) { return getInternalContextStrategy(startTime); }),
        setUser: (0, browser_core_1.monitor)(function (newUser) {
            if ((0, browser_core_1.checkUser)(newUser)) {
                userContextManager.setContext((0, browser_core_1.sanitizeUser)(newUser));
            }
        }),
        getUser: (0, browser_core_1.monitor)(userContextManager.getContext),
        setUserProperty: (0, browser_core_1.monitor)(function (key, property) {
            var _a;
            var sanitizedProperty = (0, browser_core_1.sanitizeUser)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0, browser_core_1.monitor)(userContextManager.removeContextProperty),
        clearUser: (0, browser_core_1.monitor)(userContextManager.clearContext),
    });
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0, browser_core_1.assign)({}, initConfiguration, { clientToken: 'empty' });
    }
    function canInitLogs(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                browser_core_1.display.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        return true;
    }
}
exports.makeLogsPublicApi = makeLogsPublicApi;

},{"../domain/configuration":4,"../domain/logger":7,"@datadog/browser-core":48}],2:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startLogs = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logsSessionManager_1 = require("../domain/logsSessionManager");
var configuration_1 = require("../domain/configuration");
var assembly_1 = require("../domain/assembly");
var consoleCollection_1 = require("../domain/logsCollection/console/consoleCollection");
var reportCollection_1 = require("../domain/logsCollection/report/reportCollection");
var networkErrorCollection_1 = require("../domain/logsCollection/networkError/networkErrorCollection");
var runtimeErrorCollection_1 = require("../domain/logsCollection/runtimeError/runtimeErrorCollection");
var lifeCycle_1 = require("../domain/lifeCycle");
var loggerCollection_1 = require("../domain/logsCollection/logger/loggerCollection");
var startLogsBatch_1 = require("../transport/startLogsBatch");
var startLogsBridge_1 = require("../transport/startLogsBridge");
var logger_1 = require("../domain/logger");
var internalContext_1 = require("../domain/internalContext");
function startLogs(initConfiguration, configuration, getCommonContext, mainLogger) {
    var lifeCycle = new lifeCycle_1.LifeCycle();
    var reportError = function (error) {
        return lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                error: {
                    origin: browser_core_1.ErrorSource.AGENT, // Todo: Remove in the next major release
                },
                origin: browser_core_1.ErrorSource.AGENT,
                status: logger_1.StatusType.error,
            },
        });
    };
    var pageExitObservable = (0, browser_core_1.createPageExitObservable)();
    var telemetry = startLogsTelemetry(configuration, reportError, pageExitObservable);
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = (0, assembly_1.getRUMInternalContext)()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = (0, assembly_1.getRUMInternalContext)()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = (0, assembly_1.getRUMInternalContext)()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    (0, networkErrorCollection_1.startNetworkErrorCollection)(configuration, lifeCycle);
    (0, runtimeErrorCollection_1.startRuntimeErrorCollection)(configuration, lifeCycle);
    (0, consoleCollection_1.startConsoleCollection)(configuration, lifeCycle);
    (0, reportCollection_1.startReportCollection)(configuration, lifeCycle);
    var handleLog = (0, loggerCollection_1.startLoggerCollection)(lifeCycle).handleLog;
    var session = (0, browser_core_1.areCookiesAuthorized)(configuration.cookieOptions) && !(0, browser_core_1.canUseEventBridge)() && !(0, browser_core_1.willSyntheticsInjectRum)()
        ? (0, logsSessionManager_1.startLogsSessionManager)(configuration)
        : (0, logsSessionManager_1.startLogsSessionManagerStub)(configuration);
    (0, assembly_1.startLogsAssembly)(session, configuration, lifeCycle, getCommonContext, mainLogger, reportError);
    if (!(0, browser_core_1.canUseEventBridge)()) {
        (0, startLogsBatch_1.startLogsBatch)(configuration, lifeCycle, reportError, pageExitObservable);
    }
    else {
        (0, startLogsBridge_1.startLogsBridge)(lifeCycle);
    }
    (0, browser_core_1.addTelemetryConfiguration)((0, configuration_1.serializeLogsConfiguration)(initConfiguration));
    var internalContext = (0, internalContext_1.startInternalContext)(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
    };
}
exports.startLogs = startLogs;
function startLogsTelemetry(configuration, reportError, pageExitObservable) {
    var _a;
    var telemetry = (0, browser_core_1.startTelemetry)("browser-logs-sdk" /* LOGS */, configuration);
    if ((0, browser_core_1.canUseEventBridge)()) {
        var bridge_1 = (0, browser_core_1.getEventBridge)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    else {
        var telemetryBatch_1 = (0, browser_core_1.startBatchWithReplica)(configuration, configuration.rumEndpointBuilder, reportError, pageExitObservable, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.rumEndpointBuilder);
        telemetry.observable.subscribe(function (event) { return telemetryBatch_1.add(event, (0, browser_core_1.isTelemetryReplicationAllowed)(configuration)); });
    }
    return telemetry;
}

},{"../domain/assembly":3,"../domain/configuration":4,"../domain/internalContext":5,"../domain/lifeCycle":6,"../domain/logger":7,"../domain/logsCollection/console/consoleCollection":8,"../domain/logsCollection/logger/loggerCollection":9,"../domain/logsCollection/networkError/networkErrorCollection":10,"../domain/logsCollection/report/reportCollection":11,"../domain/logsCollection/runtimeError/runtimeErrorCollection":12,"../domain/logsSessionManager":13,"../transport/startLogsBatch":15,"../transport/startLogsBridge":16,"@datadog/browser-core":48}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetRUMInternalContext = exports.getRUMInternalContext = exports.startLogsAssembly = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("./logger");
var loggerCollection_1 = require("./logsCollection/logger/loggerCollection");
function startLogsAssembly(sessionManager, configuration, lifeCycle, getCommonContext, mainLogger, // Todo: [RUMF-1230] Remove this parameter in the next major release
reportError) {
    var statusWithCustom = logger_1.STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = (0, browser_core_1.createEventRateLimiter)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c, _d;
        var rawLogsEvent = _a.rawLogsEvent, _e = _a.messageContext, messageContext = _e === void 0 ? undefined : _e, _f = _a.savedCommonContext, savedCommonContext = _f === void 0 ? undefined : _f, _g = _a.logger, logger = _g === void 0 ? mainLogger : _g;
        var startTime = (0, browser_core_1.getRelativeTime)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return;
        }
        var commonContext = savedCommonContext || getCommonContext();
        var log = (0, browser_core_1.combine)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0, browser_core_1.isEmptyObject)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, logger.getContext(), messageContext);
        if (
        // Todo: [RUMF-1230] Move this check to the logger collection in the next major release
        !(0, loggerCollection_1.isAuthorized)(rawLogsEvent.status, logger_1.HandlerType.http, logger) ||
            ((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log)) === false ||
            (((_c = log.error) === null || _c === void 0 ? void 0 : _c.origin) !== browser_core_1.ErrorSource.AGENT &&
                ((_d = logRateLimiters[log.status]) !== null && _d !== void 0 ? _d : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LOG_COLLECTED */, log);
    });
}
exports.startLogsAssembly = startLogsAssembly;
var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if ((0, browser_core_1.willSyntheticsInjectRum)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            (0, browser_core_1.addTelemetryDebug)('Logs sent before RUM is injected by the synthetics worker', {
                testId: (0, browser_core_1.getSyntheticsTestId)(),
                resultId: (0, browser_core_1.getSyntheticsResultId)(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
exports.getRUMInternalContext = getRUMInternalContext;
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
exports.resetRUMInternalContext = resetRUMInternalContext;

},{"./logger":7,"./logsCollection/logger/loggerCollection":9,"@datadog/browser-core":48}],4:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeLogsConfiguration = exports.validateAndBuildForwardOption = exports.validateAndBuildLogsConfiguration = exports.DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * arbitrary value, byte precision not needed
 */
exports.DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * browser_core_1.ONE_KIBI_BYTE;
function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = (0, browser_core_1.validateAndBuildConfiguration)(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, (0, browser_core_1.objectValues)(browser_core_1.ConsoleApiName), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, (0, browser_core_1.objectValues)(browser_core_1.RawReportType), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !(0, browser_core_1.includes)(forwardConsoleLogs, browser_core_1.ConsoleApiName.error)) {
        forwardConsoleLogs.push(browser_core_1.ConsoleApiName.error);
    }
    return (0, browser_core_1.assign)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: exports.DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
    }, baseConfiguration);
}
exports.validateAndBuildLogsConfiguration = validateAndBuildLogsConfiguration;
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return (0, browser_core_1.includes)(allowedValues, api); })))) {
        browser_core_1.display.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : (0, browser_core_1.removeDuplicates)(option);
}
exports.validateAndBuildForwardOption = validateAndBuildForwardOption;
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = (0, browser_core_1.serializeConfiguration)(configuration);
    return (0, browser_core_1.assign)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
    }, baseSerializedInitConfiguration);
}
exports.serializeLogsConfiguration = serializeLogsConfiguration;

},{"@datadog/browser-core":48}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInternalContext = void 0;
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
exports.startInternalContext = startInternalContext;

},{}],6:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeCycle = void 0;
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());
exports.LifeCycle = LifeCycle;

},{}],7:[function(require,module,exports){
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.STATUSES = exports.HandlerType = exports.StatusType = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
exports.HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
exports.STATUSES = Object.keys(exports.StatusType);
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = exports.HandlerType.http; }
        if (level === void 0) { level = exports.StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0, browser_core_1.createContextManager)();
        this.contextManager.set((0, browser_core_1.assign)({}, loggerContext, name ? { logger: { name: name } } : undefined));
    }
    Logger.prototype.log = function (message, messageContext, status) {
        if (status === void 0) { status = exports.StatusType.info; }
        this.handleLogStrategy({ message: message, context: (0, browser_core_1.deepClone)(messageContext), status: status }, this);
    };
    Logger.prototype.debug = function (message, messageContext) {
        this.log(message, messageContext, exports.StatusType.debug);
    };
    Logger.prototype.info = function (message, messageContext) {
        this.log(message, messageContext, exports.StatusType.info);
    };
    Logger.prototype.warn = function (message, messageContext) {
        this.log(message, messageContext, exports.StatusType.warn);
    };
    Logger.prototype.error = function (message, messageContext) {
        var errorOrigin = {
            error: {
                origin: browser_core_1.ErrorSource.LOGGER,
            },
        };
        this.log(message, (0, browser_core_1.combine)(errorOrigin, messageContext), exports.StatusType.error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.set(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.get();
    };
    Logger.prototype.addContext = function (key, value) {
        this.contextManager.add(key, value);
    };
    Logger.prototype.removeContext = function (key) {
        this.contextManager.remove(key);
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        browser_core_1.monitored
    ], Logger.prototype, "log", null);
    return Logger;
}());
exports.Logger = Logger;

},{"@datadog/browser-core":48}],8:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.startConsoleCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
var LogStatusForApi = (_a = {},
    _a[browser_core_1.ConsoleApiName.log] = logger_1.StatusType.info,
    _a[browser_core_1.ConsoleApiName.debug] = logger_1.StatusType.debug,
    _a[browser_core_1.ConsoleApiName.info] = logger_1.StatusType.info,
    _a[browser_core_1.ConsoleApiName.warn] = logger_1.StatusType.warn,
    _a[browser_core_1.ConsoleApiName.error] = logger_1.StatusType.error,
    _a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = (0, browser_core_1.initConsoleObservable)(configuration.forwardConsoleLogs).subscribe(function (log) {
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0, browser_core_1.timeStampNow)(),
                message: log.message,
                origin: browser_core_1.ErrorSource.CONSOLE,
                error: log.api === browser_core_1.ConsoleApiName.error
                    ? {
                        origin: browser_core_1.ErrorSource.CONSOLE,
                        stack: log.stack,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
        });
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
exports.startConsoleCollection = startConsoleCollection;

},{"../../logger":7,"@datadog/browser-core":48}],9:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthorized = exports.startLoggerCollection = exports.STATUS_PRIORITIES = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
exports.STATUS_PRIORITIES = (_a = {},
    _a[logger_1.StatusType.debug] = 0,
    _a[logger_1.StatusType.info] = 1,
    _a[logger_1.StatusType.warn] = 2,
    _a[logger_1.StatusType.error] = 3,
    _a);
function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = logsMessage.context;
        if (isAuthorized(logsMessage.status, logger_1.HandlerType.console, logger)) {
            (0, browser_core_1.display)(logsMessage.status, logsMessage.message, (0, browser_core_1.combine)(logger.getContext(), messageContext));
        }
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: savedDate || (0, browser_core_1.timeStampNow)(),
                message: logsMessage.message,
                status: logsMessage.status,
                origin: browser_core_1.ErrorSource.LOGGER,
            },
            messageContext: messageContext,
            savedCommonContext: savedCommonContext,
            logger: logger,
        });
    }
    return {
        handleLog: handleLog,
    };
}
exports.startLoggerCollection = startLoggerCollection;
function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (exports.STATUS_PRIORITIES[status] >= exports.STATUS_PRIORITIES[logger.getLevel()] && (0, browser_core_1.includes)(sanitizedHandlerType, handlerType));
}
exports.isAuthorized = isAuthorized;

},{"../../logger":7,"@datadog/browser-core":48}],10:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeFetchResponseText = exports.computeFetchErrorText = exports.computeXhrResponseData = exports.startNetworkErrorCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: browser_core_1.noop };
    }
    var xhrSubscription = (0, browser_core_1.initXhrObservable)().subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* XHR */, context);
        }
    });
    var fetchSubscription = (0, browser_core_1.initFetchObservable)().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || isServerError(request))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        origin: browser_core_1.ErrorSource.NETWORK,
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url,
                    },
                    status: logger_1.StatusType.error,
                    origin: browser_core_1.ErrorSource.NETWORK,
                },
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
exports.startNetworkErrorCollection = startNetworkErrorCollection;
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
exports.computeXhrResponseData = computeXhrResponseData;
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText((0, browser_core_1.toStackTraceString)((0, browser_core_1.computeStackTrace)(error)), configuration));
}
exports.computeFetchErrorText = computeFetchErrorText;
function computeFetchResponseText(response, configuration, callback) {
    if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        response
            .clone()
            .text()
            .then((0, browser_core_1.monitor)(function (text) { return callback(truncateResponseText(text, configuration)); }), (0, browser_core_1.monitor)(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else if (!response.body) {
        callback();
    }
    else {
        truncateResponseStream(response.clone().body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
exports.computeFetchResponseText = computeFetchResponseText;
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function isServerError(request) {
    return request.status >= 500;
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    (0, browser_core_1.readBytesFromStream)(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}

},{"../../logger":7,"@datadog/browser-core":48}],11:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.startReportCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
var LogStatusForReport = (_a = {},
    _a[browser_core_1.RawReportType.cspViolation] = logger_1.StatusType.error,
    _a[browser_core_1.RawReportType.intervention] = logger_1.StatusType.error,
    _a[browser_core_1.RawReportType.deprecation] = logger_1.StatusType.warn,
    _a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = (0, browser_core_1.initReportObservable)(configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === logger_1.StatusType.error) {
            error = {
                kind: report.subtype,
                origin: browser_core_1.ErrorSource.REPORT,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0, browser_core_1.getFileFromStackTraceString)(report.stack));
        }
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0, browser_core_1.timeStampNow)(),
                message: message,
                origin: browser_core_1.ErrorSource.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
exports.startReportCollection = startReportCollection;

},{"../../logger":7,"@datadog/browser-core":48}],12:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRuntimeErrorCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: browser_core_1.noop };
    }
    var rawErrorObservable = new browser_core_1.Observable();
    var stopRuntimeErrorTracking = (0, browser_core_1.trackRuntimeError)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    origin: browser_core_1.ErrorSource.SOURCE,
                    stack: rawError.stack,
                },
                origin: browser_core_1.ErrorSource.SOURCE,
                status: logger_1.StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
exports.startRuntimeErrorCollection = startRuntimeErrorCollection;

},{"../../logger":7,"@datadog/browser-core":48}],13:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startLogsSessionManagerStub = exports.startLogsSessionManager = exports.LOGS_SESSION_KEY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration) {
    var sessionManager = (0, browser_core_1.startSessionManager)(configuration.cookieOptions, exports.LOGS_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
    };
}
exports.startLogsSessionManager = startLogsSessionManager;
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
    };
}
exports.startLogsSessionManagerStub = startLogsSessionManagerStub;
function computeTrackingType(configuration) {
    if (!(0, browser_core_1.performDraw)(configuration.sampleRate)) {
        return "0" /* NOT_TRACKED */;
    }
    return "1" /* TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* NOT_TRACKED */ || trackingType === "1" /* TRACKED */;
}

},{"@datadog/browser-core":48}],14:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogLogs = exports.HandlerType = exports.StatusType = exports.Logger = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logsPublicApi_1 = require("../boot/logsPublicApi");
var startLogs_1 = require("../boot/startLogs");
var logger_1 = require("../domain/logger");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return logger_1.Logger; } });
Object.defineProperty(exports, "StatusType", { enumerable: true, get: function () { return logger_1.StatusType; } });
Object.defineProperty(exports, "HandlerType", { enumerable: true, get: function () { return logger_1.HandlerType; } });
exports.datadogLogs = (0, logsPublicApi_1.makeLogsPublicApi)(startLogs_1.startLogs);
(0, browser_core_1.defineGlobal)((0, browser_core_1.getGlobalObject)(), 'DD_LOGS', exports.datadogLogs);

},{"../boot/logsPublicApi":1,"../boot/startLogs":2,"../domain/logger":7,"@datadog/browser-core":48}],15:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startLogsBatch = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable) {
    var _a;
    var batch = (0, browser_core_1.startBatchWithReplica)(configuration, configuration.logsEndpointBuilder, reportError, pageExitObservable, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.logsEndpointBuilder);
    lifeCycle.subscribe(1 /* LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
}
exports.startLogsBatch = startLogsBatch;

},{"@datadog/browser-core":48}],16:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startLogsBridge = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startLogsBridge(lifeCycle) {
    var bridge = (0, browser_core_1.getEventBridge)();
    lifeCycle.subscribe(1 /* LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
exports.startLogsBridge = startLogsBridge;

},{"@datadog/browser-core":48}],17:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineGlobal = exports.makePublicApi = void 0;
var catchUserErrors_1 = require("../tools/catchUserErrors");
var monitor_1 = require("../tools/monitor");
var utils_1 = require("../tools/utils");
function makePublicApi(stub) {
    var publicApi = (0, utils_1.assign)({
        version: "4.26.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return monitor_1.setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
exports.makePublicApi = makePublicApi;
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0, catchUserErrors_1.catchUserErrors)(fn, 'onReady callback threw an error:')(); });
    }
}
exports.defineGlobal = defineGlobal;

},{"../tools/catchUserErrors":51,"../tools/monitor":59,"../tools/utils":64}],18:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentSite = exports.areCookiesAuthorized = exports.deleteCookie = exports.getCookie = exports.setCookie = exports.COOKIE_ACCESS_DELAY = void 0;
var display_1 = require("../tools/display");
var utils_1 = require("../tools/utils");
exports.COOKIE_ACCESS_DELAY = utils_1.ONE_SECOND;
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
exports.setCookie = setCookie;
function getCookie(name) {
    return (0, utils_1.findCommaSeparatedValue)(document.cookie, name);
}
exports.getCookie = getCookie;
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
exports.deleteCookie = deleteCookie;
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0, utils_1.generateUUID)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, utils_1.ONE_SECOND, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display_1.display.error(error);
        return false;
    }
}
exports.areCookiesAuthorized = areCookiesAuthorized;
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0, utils_1.generateUUID)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, utils_1.ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
exports.getCurrentSite = getCurrentSite;

},{"../tools/display":55,"../tools/utils":64}],19:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFetchObservable = void 0;
var instrumentMethod_1 = require("../tools/instrumentMethod");
var monitor_1 = require("../tools/monitor");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/timeUtils");
var urlPolyfill_1 = require("../tools/urlPolyfill");
var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
exports.initFetchObservable = initFetchObservable;
function createFetchObservable() {
    var observable = new observable_1.Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0, instrumentMethod_1.instrumentMethod)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0, monitor_1.callMonitored)(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0, monitor_1.callMonitored)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var url = (0, urlPolyfill_1.normalizeUrl)((typeof input === 'object' && input.url) || input);
    var startClocks = (0, timeUtils_1.clocksNow)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        context.resolveDuration = (0, timeUtils_1.elapsed)(startContext.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0, monitor_1.monitor)(reportFetch), (0, monitor_1.monitor)(reportFetch));
}

},{"../tools/instrumentMethod":57,"../tools/monitor":59,"../tools/observable":60,"../tools/timeUtils":62,"../tools/urlPolyfill":63}],20:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageExitObservable = void 0;
var observable_1 = require("../tools/observable");
var utils_1 = require("../tools/utils");
function createPageExitObservable() {
    var observable = new observable_1.Observable(function () {
        /**
         * Only event that guarantee to fire on mobile devices when the page transitions to background state
         * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
         */
        var stopVisibilityChangeListener = (0, utils_1.addEventListener)(document, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
            if (document.visibilityState === 'hidden') {
                observable.notify({ reason: "visibility_hidden" /* HIDDEN */ });
            }
        }, { capture: true }).stop;
        /**
         * Safari does not support yet to send a request during:
         * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
         * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
         */
        var stopBeforeUnloadListener = (0, utils_1.addEventListener)(window, "beforeunload" /* BEFORE_UNLOAD */, function () {
            observable.notify({ reason: "before_unload" /* UNLOADING */ });
        }).stop;
        return function () {
            stopVisibilityChangeListener();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
exports.createPageExitObservable = createPageExitObservable;

},{"../tools/observable":60,"../tools/utils":64}],21:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initXhrObservable = void 0;
var instrumentMethod_1 = require("../tools/instrumentMethod");
var monitor_1 = require("../tools/monitor");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/timeUtils");
var urlPolyfill_1 = require("../tools/urlPolyfill");
var utils_1 = require("../tools/utils");
var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
exports.initXhrObservable = initXhrObservable;
function createXhrObservable() {
    var observable = new observable_1.Observable(function () {
        var stopInstrumentingStart = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: (0, urlPolyfill_1.normalizeUrl)(String(url)),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = (0, timeUtils_1.relativeNow)();
    startContext.startClocks = (0, timeUtils_1.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = (0, monitor_1.monitor)(function () {
        _this.removeEventListener('loadend', onEnd);
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0, timeUtils_1.elapsed)(startContext.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());
        completeContext.status = _this.status;
        observable.notify((0, utils_1.shallowClone)(completeContext));
    });
    this.addEventListener('loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}

},{"../tools/instrumentMethod":57,"../tools/monitor":59,"../tools/observable":60,"../tools/timeUtils":62,"../tools/urlPolyfill":63,"../tools/utils":64}],22:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeConfiguration = exports.buildCookieOptions = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = void 0;
var cookie_1 = require("../../browser/cookie");
var catchUserErrors_1 = require("../../tools/catchUserErrors");
var display_1 = require("../../tools/display");
var utils_1 = require("../../tools/utils");
var experimentalFeatures_1 = require("./experimentalFeatures");
var transportConfiguration_1 = require("./transportConfiguration");
exports.DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display_1.display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.sampleRate !== undefined && !(0, utils_1.isPercentage)(initConfiguration.sampleRate)) {
        display_1.display.error('Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0, utils_1.isPercentage)(initConfiguration.telemetrySampleRate)) {
        display_1.display.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0, utils_1.isPercentage)(initConfiguration.telemetryConfigurationSampleRate)) {
        display_1.display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    (0, experimentalFeatures_1.updateExperimentalFeatures)(initConfiguration.enableExperimentalFeatures);
    return (0, utils_1.assign)({
        beforeSend: initConfiguration.beforeSend && (0, catchUserErrors_1.catchUserErrors)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        cookieOptions: buildCookieOptions(initConfiguration),
        sampleRate: (_a = initConfiguration.sampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * utils_1.ONE_KIBI_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: 30 * utils_1.ONE_SECOND,
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * utils_1.ONE_KIBI_BYTE,
    }, (0, transportConfiguration_1.computeTransportConfiguration)(initConfiguration));
}
exports.validateAndBuildConfiguration = validateAndBuildConfiguration;
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(initConfiguration);
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0, cookie_1.getCurrentSite)();
    }
    return cookieOptions;
}
exports.buildCookieOptions = buildCookieOptions;
function mustUseSecureCookie(initConfiguration) {
    return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}
function serializeConfiguration(configuration) {
    return {
        session_sample_rate: configuration.sampleRate,
        telemetry_sample_rate: configuration.telemetrySampleRate,
        telemetry_configuration_sample_rate: configuration.telemetryConfigurationSampleRate,
        use_before_send: !!configuration.beforeSend,
        use_cross_site_session_cookie: configuration.useCrossSiteSessionCookie,
        use_secure_session_cookie: configuration.useSecureSessionCookie,
        use_proxy: configuration.proxyUrl !== undefined ? !!configuration.proxyUrl : undefined,
        silent_multiple_init: configuration.silentMultipleInit,
        track_session_across_subdomains: configuration.trackSessionAcrossSubdomains,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
    };
}
exports.serializeConfiguration = serializeConfiguration;

},{"../../browser/cookie":18,"../../tools/catchUserErrors":51,"../../tools/display":55,"../../tools/utils":64,"./experimentalFeatures":24,"./transportConfiguration":28}],23:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpointBuilder = exports.ENDPOINTS = void 0;
var timeUtils_1 = require("../../tools/timeUtils");
var urlPolyfill_1 = require("../../tools/urlPolyfill");
var utils_1 = require("../../tools/utils");
var intakeSites_1 = require("./intakeSites");
exports.ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites_1.INTAKE_SITE_US1 : _a, clientToken = initConfiguration.clientToken;
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var host = "".concat(exports.ENDPOINTS[endpointType], ".browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
    var baseUrl = "https://".concat(host, "/api/v2/").concat(INTAKE_TRACKS[endpointType]);
    var proxyUrl = initConfiguration.proxyUrl && (0, urlPolyfill_1.normalizeUrl)(initConfiguration.proxyUrl);
    return {
        build: function (api, retry) {
            var tags = ["sdk_version:".concat("4.26.0"), "api:".concat(api)].concat(configurationTags);
            if (retry) {
                tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
            }
            var parameters = 'ddsource=browser' +
                "&ddtags=".concat(encodeURIComponent(tags.join(','))) +
                "&dd-api-key=".concat(clientToken) +
                "&dd-evp-origin-version=".concat(encodeURIComponent("4.26.0")) +
                '&dd-evp-origin=browser' +
                "&dd-request-id=".concat((0, utils_1.generateUUID)());
            if (endpointType === 'rum') {
                parameters += "&batch_time=".concat((0, timeUtils_1.timeStampNow)());
            }
            var endpointUrl = "".concat(baseUrl, "?").concat(parameters);
            return proxyUrl ? "".concat(proxyUrl, "?ddforward=").concat(encodeURIComponent(endpointUrl)) : endpointUrl;
        },
        buildIntakeUrl: function () {
            return proxyUrl ? "".concat(proxyUrl, "?ddforward") : baseUrl;
        },
        endpointType: endpointType,
    };
}
exports.createEndpointBuilder = createEndpointBuilder;

},{"../../tools/timeUtils":62,"../../tools/urlPolyfill":63,"../../tools/utils":64,"./intakeSites":26}],24:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.updateExperimentalFeatures = void 0;
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */
var utils_1 = require("../../tools/utils");
var display_1 = require("../../tools/display");
var enabledExperimentalFeatures;
function updateExperimentalFeatures(enabledFeatures) {
    // Safely handle external data
    if (!Array.isArray(enabledFeatures)) {
        return;
    }
    if (!enabledExperimentalFeatures) {
        enabledExperimentalFeatures = new Set(enabledFeatures);
    }
    enabledFeatures
        .filter(function (flag) { return typeof flag === 'string'; })
        .forEach(function (flag) {
        if ((0, utils_1.includes)(flag, '-')) {
            display_1.display.warn("please use snake case for '".concat(flag, "'"));
        }
        enabledExperimentalFeatures.add(flag);
    });
}
exports.updateExperimentalFeatures = updateExperimentalFeatures;
function isExperimentalFeatureEnabled(featureName) {
    return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}
exports.isExperimentalFeatureEnabled = isExperimentalFeatureEnabled;
function resetExperimentalFeatures() {
    enabledExperimentalFeatures = new Set();
}
exports.resetExperimentalFeatures = resetExperimentalFeatures;
function getExperimentalFeatures() {
    return enabledExperimentalFeatures || new Set();
}
exports.getExperimentalFeatures = getExperimentalFeatures;

},{"../../tools/display":55,"../../tools/utils":64}],25:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.updateExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.createEndpointBuilder = exports.serializeConfiguration = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = exports.buildCookieOptions = void 0;
var configuration_1 = require("./configuration");
Object.defineProperty(exports, "buildCookieOptions", { enumerable: true, get: function () { return configuration_1.buildCookieOptions; } });
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return configuration_1.DefaultPrivacyLevel; } });
Object.defineProperty(exports, "validateAndBuildConfiguration", { enumerable: true, get: function () { return configuration_1.validateAndBuildConfiguration; } });
Object.defineProperty(exports, "serializeConfiguration", { enumerable: true, get: function () { return configuration_1.serializeConfiguration; } });
var endpointBuilder_1 = require("./endpointBuilder");
Object.defineProperty(exports, "createEndpointBuilder", { enumerable: true, get: function () { return endpointBuilder_1.createEndpointBuilder; } });
var experimentalFeatures_1 = require("./experimentalFeatures");
Object.defineProperty(exports, "isExperimentalFeatureEnabled", { enumerable: true, get: function () { return experimentalFeatures_1.isExperimentalFeatureEnabled; } });
Object.defineProperty(exports, "updateExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.updateExperimentalFeatures; } });
Object.defineProperty(exports, "resetExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.resetExperimentalFeatures; } });
Object.defineProperty(exports, "getExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.getExperimentalFeatures; } });
__exportStar(require("./intakeSites"), exports);

},{"./configuration":22,"./endpointBuilder":23,"./experimentalFeatures":24,"./intakeSites":26}],26:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTAKE_SITE_US1_FED = exports.INTAKE_SITE_US1 = exports.INTAKE_SITE_STAGING = void 0;
exports.INTAKE_SITE_STAGING = 'datad0g.com';
exports.INTAKE_SITE_US1 = 'datadoghq.com';
exports.INTAKE_SITE_US1_FED = 'ddog-gov.com';

},{}],27:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTag = exports.buildTags = exports.TAG_SIZE_LIMIT = void 0;
var display_1 = require("../../tools/display");
exports.TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
exports.buildTags = buildTags;
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = exports.TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display_1.display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
exports.buildTag = buildTag;

},{"../../tools/display":55}],28:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTransportConfiguration = void 0;
var utils_1 = require("../../tools/utils");
var endpointBuilder_1 = require("./endpointBuilder");
var tags_1 = require("./tags");
var intakeSites_1 = require("./intakeSites");
function computeTransportConfiguration(initConfiguration) {
    var tags = (0, tags_1.buildTags)(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeEndpoints = (0, utils_1.objectValues)(endpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags);
    return (0, utils_1.assign)({
        isIntakeUrl: function (url) { return intakeEndpoints.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites_1.INTAKE_SITE_US1,
    }, endpointBuilders);
}
exports.computeTransportConfiguration = computeTransportConfiguration;
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0, utils_1.assign)({}, initConfiguration, {
        site: intakeSites_1.INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'rum', tags),
    };
    intakeEndpoints.push.apply(intakeEndpoints, (0, utils_1.objectValues)(replicaEndpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); }));
    return (0, utils_1.assign)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}

},{"../../tools/utils":64,"./endpointBuilder":23,"./intakeSites":26,"./tags":27}],29:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConsoleObservable = void 0;
var tracekit_1 = require("../tracekit");
var error_1 = require("../../tools/error");
var observable_1 = require("../../tools/observable");
var utils_1 = require("../../tools/utils");
var display_1 = require("../../tools/display");
var monitor_1 = require("../../tools/monitor");
var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return observable_1.mergeObservables.apply(void 0, consoleObservables);
}
exports.initConsoleObservable = initConsoleObservable;
/* eslint-disable no-console */
function createConsoleObservable(api) {
    var observable = new observable_1.Observable(function () {
        var originalConsoleApi = console[api];
        console[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0, error_1.createHandlingStack)();
            (0, monitor_1.callMonitored)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            console[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    if (api === display_1.ConsoleApiName.error) {
        var firstErrorParam = (0, utils_1.find)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0, error_1.toStackTraceString)((0, tracekit_1.computeStackTrace)(firstErrorParam)) : undefined;
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return (0, error_1.formatErrorMessage)((0, tracekit_1.computeStackTrace)(param));
    }
    return (0, utils_1.jsonStringify)(param, undefined, 2);
}

},{"../../tools/display":55,"../../tools/error":56,"../../tools/monitor":59,"../../tools/observable":60,"../../tools/utils":64,"../tracekit":43}],30:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRuntimeError = void 0;
var error_1 = require("../../tools/error");
var timeUtils_1 = require("../../tools/timeUtils");
var tracekit_1 = require("../tracekit");
function trackRuntimeError(errorObservable) {
    return (0, tracekit_1.startUnhandledErrorCollection)(function (stackTrace, originalError) {
        errorObservable.notify((0, error_1.computeRawError)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0, timeUtils_1.clocksNow)(),
            nonErrorPrefix: 'Uncaught',
            source: error_1.ErrorSource.SOURCE,
            handling: "unhandled" /* UNHANDLED */,
        }));
    });
}
exports.trackRuntimeError = trackRuntimeError;

},{"../../tools/error":56,"../../tools/timeUtils":62,"../tracekit":43}],31:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReportObservable = exports.RawReportType = void 0;
var error_1 = require("../../tools/error");
var monitor_1 = require("../../tools/monitor");
var observable_1 = require("../../tools/observable");
var utils_1 = require("../../tools/utils");
exports.RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if ((0, utils_1.includes)(apis, exports.RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== exports.RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return observable_1.mergeObservables.apply(void 0, observables);
}
exports.initReportObservable = initReportObservable;
function createReportObservable(reportTypes) {
    var observable = new observable_1.Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0, monitor_1.monitor)(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new observable_1.Observable(function () {
        var handleCspViolation = (0, monitor_1.monitor)(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = (0, utils_1.addEventListener)(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = exports.RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: exports.RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0, utils_1.safeTruncate)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        (0, error_1.toStackTraceString)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}

},{"../../tools/error":56,"../../tools/monitor":59,"../../tools/observable":60,"../../tools/utils":64}],32:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryOldCookiesMigration = exports.LOGS_SESSION_KEY = exports.RUM_SESSION_KEY = exports.OLD_LOGS_COOKIE_NAME = exports.OLD_RUM_COOKIE_NAME = exports.OLD_SESSION_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
var sessionCookieStore_1 = require("./sessionCookieStore");
exports.OLD_SESSION_COOKIE_NAME = '_dd';
exports.OLD_RUM_COOKIE_NAME = '_dd_r';
exports.OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
exports.RUM_SESSION_KEY = 'rum';
exports.LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(options) {
    var sessionString = (0, cookie_1.getCookie)(sessionCookieStore_1.SESSION_COOKIE_NAME);
    var oldSessionId = (0, cookie_1.getCookie)(exports.OLD_SESSION_COOKIE_NAME);
    var oldRumType = (0, cookie_1.getCookie)(exports.OLD_RUM_COOKIE_NAME);
    var oldLogsType = (0, cookie_1.getCookie)(exports.OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[exports.LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[exports.RUM_SESSION_KEY] = oldRumType;
        }
        (0, sessionCookieStore_1.persistSession)(session, options);
    }
}
exports.tryOldCookiesMigration = tryOldCookiesMigration;

},{"../../browser/cookie":18,"./sessionCookieStore":34}],33:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_EXPIRATION_DELAY = exports.SESSION_TIME_OUT_DELAY = void 0;
var utils_1 = require("../../tools/utils");
exports.SESSION_TIME_OUT_DELAY = 4 * utils_1.ONE_HOUR;
exports.SESSION_EXPIRATION_DELAY = 15 * utils_1.ONE_MINUTE;

},{"../../tools/utils":64}],34:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveSession = exports.toSessionString = exports.persistSession = exports.withCookieLockAccess = exports.MAX_NUMBER_OF_LOCK_RETRIES = exports.LOCK_RETRY_DELAY = exports.SESSION_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
var browserDetection_1 = require("../../tools/browserDetection");
var monitor_1 = require("../../tools/monitor");
var timeUtils_1 = require("../../tools/timeUtils");
var utils = __importStar(require("../../tools/utils"));
var sessionConstants_1 = require("./sessionConstants");
var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
exports.SESSION_COOKIE_NAME = '_dd_s';
// arbitrary values
exports.LOCK_RETRY_DELAY = 10;
exports.MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function withCookieLockAccess(operations, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (numberOfRetries >= exports.MAX_NUMBER_OF_LOCK_RETRIES) {
        next();
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isCookieLockEnabled()) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = utils.generateUUID();
        currentSession.lock = currentLock;
        setSession(currentSession, operations.options);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isCookieLockEnabled()) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        persistSession(processedSession, operations.options);
    }
    if (isCookieLockEnabled()) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            setSession(currentSession, operations.options);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date cookie value, the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next();
}
exports.withCookieLockAccess = withCookieLockAccess;
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */
function isCookieLockEnabled() {
    return (0, browserDetection_1.isChromium)();
}
function retryLater(operations, currentNumberOfRetries) {
    setTimeout((0, monitor_1.monitor)(function () {
        withCookieLockAccess(operations, currentNumberOfRetries + 1);
    }), exports.LOCK_RETRY_DELAY);
}
function next() {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        withCookieLockAccess(nextOperations);
    }
}
function persistSession(session, options) {
    if (isExpiredState(session)) {
        clearSession(options);
        return;
    }
    session.expire = String((0, timeUtils_1.dateNow)() + sessionConstants_1.SESSION_EXPIRATION_DELAY);
    setSession(session, options);
}
exports.persistSession = persistSession;
function setSession(session, options) {
    (0, cookie_1.setCookie)(exports.SESSION_COOKIE_NAME, toSessionString(session), sessionConstants_1.SESSION_EXPIRATION_DELAY, options);
}
function toSessionString(session) {
    return utils
        .objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
exports.toSessionString = toSessionString;
function retrieveSession() {
    var sessionString = (0, cookie_1.getCookie)(exports.SESSION_COOKIE_NAME);
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
exports.retrieveSession = retrieveSession;
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function isExpiredState(session) {
    return utils.isEmptyObject(session);
}
function clearSession(options) {
    (0, cookie_1.setCookie)(exports.SESSION_COOKIE_NAME, '', 0, options);
}

},{"../../browser/cookie":18,"../../tools/browserDetection":50,"../../tools/monitor":59,"../../tools/timeUtils":62,"../../tools/utils":64,"./sessionConstants":33}],35:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopSessionManager = exports.startSessionManager = exports.VISIBILITY_CHECK_DELAY = void 0;
var utils = __importStar(require("../../tools/utils"));
var contextHistory_1 = require("../../tools/contextHistory");
var timeUtils_1 = require("../../tools/timeUtils");
var monitor_1 = require("../../tools/monitor");
var oldCookiesMigration_1 = require("./oldCookiesMigration");
var sessionStore_1 = require("./sessionStore");
var sessionConstants_1 = require("./sessionConstants");
exports.VISIBILITY_CHECK_DELAY = utils.ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants_1.SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(options, productKey, computeSessionState) {
    (0, oldCookiesMigration_1.tryOldCookiesMigration)(options);
    var sessionStore = (0, sessionStore_1.startSessionStore)(options, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new contextHistory_1.ContextHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.relativeNow)());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive((0, timeUtils_1.relativeNow)());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.clocksOrigin)().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
    };
}
exports.startSessionManager = startSessionManager;
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
exports.stopSessionManager = stopSessionManager;
function trackActivity(expandOrRenewSession) {
    var stop = utils.addEventListeners(window, ["click" /* CLICK */, "touchstart" /* TOUCH_START */, "keydown" /* KEY_DOWN */, "scroll" /* SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = (0, monitor_1.monitor)(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = utils.addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = setInterval(expandSessionWhenVisible, exports.VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        clearInterval(visibilityCheckInterval);
    });
}

},{"../../tools/contextHistory":52,"../../tools/monitor":59,"../../tools/timeUtils":62,"../../tools/utils":64,"./oldCookiesMigration":32,"./sessionConstants":33,"./sessionStore":36}],36:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startSessionStore = void 0;
var cookie_1 = require("../../browser/cookie");
var monitor_1 = require("../../tools/monitor");
var observable_1 = require("../../tools/observable");
var timeUtils_1 = require("../../tools/timeUtils");
var utils = __importStar(require("../../tools/utils"));
var sessionConstants_1 = require("./sessionConstants");
var sessionCookieStore_1 = require("./sessionCookieStore");
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(options, productKey, computeSessionState) {
    var renewObservable = new observable_1.Observable();
    var expireObservable = new observable_1.Observable();
    var watchSessionTimeoutId = setInterval((0, monitor_1.monitor)(watchSession), cookie_1.COOKIE_ACCESS_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        (0, sessionCookieStore_1.withCookieLockAccess)({
            options: options,
            process: function (cookieSession) {
                var synchronizedSession = synchronizeSession(cookieSession);
                isTracked = expandOrRenewCookie(synchronizedSession);
                return synchronizedSession;
            },
            after: function (cookieSession) {
                if (isTracked && !hasSessionInCache()) {
                    renewSession(cookieSession);
                }
                sessionCache = cookieSession;
            },
        });
    }
    function expandSession() {
        (0, sessionCookieStore_1.withCookieLockAccess)({
            options: options,
            process: function (cookieSession) { return (hasSessionInCache() ? synchronizeSession(cookieSession) : undefined); },
        });
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session cookie
     * - if the session is not active, clear the session cookie and expire the session cache
     */
    function watchSession() {
        (0, sessionCookieStore_1.withCookieLockAccess)({
            options: options,
            process: function (cookieSession) { return (!isActiveSession(cookieSession) ? {} : undefined); },
            after: synchronizeSession,
        });
    }
    function synchronizeSession(cookieSession) {
        if (!isActiveSession(cookieSession)) {
            cookieSession = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(cookieSession)) {
                expireSession();
            }
            else {
                sessionCache = cookieSession;
            }
        }
        return cookieSession;
    }
    function expandOrRenewCookie(cookieSession) {
        var _a = computeSessionState(cookieSession[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        cookieSession[productKey] = trackingType;
        if (isTracked && !cookieSession.id) {
            cookieSession.id = utils.generateUUID();
            cookieSession.created = String((0, timeUtils_1.dateNow)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(cookieSession) {
        return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
    }
    function expireSession() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSession(cookieSession) {
        sessionCache = cookieSession;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = (0, sessionCookieStore_1.retrieveSession)();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(session) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((session.created === undefined || (0, timeUtils_1.dateNow)() - Number(session.created) < sessionConstants_1.SESSION_TIME_OUT_DELAY) &&
            (session.expire === undefined || (0, timeUtils_1.dateNow)() < Number(session.expire)));
    }
    return {
        expandOrRenewSession: utils.throttle((0, monitor_1.monitor)(expandOrRenewSession), cookie_1.COOKIE_ACCESS_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        stop: function () {
            clearInterval(watchSessionTimeoutId);
        },
    };
}
exports.startSessionStore = startSessionStore;

},{"../../browser/cookie":18,"../../tools/monitor":59,"../../tools/observable":60,"../../tools/timeUtils":62,"../../tools/utils":64,"./sessionConstants":33,"./sessionCookieStore":34}],37:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = exports.SYNTHETICS_TEST_ID_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
exports.SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, cookie_1.getCookie)(exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
exports.willSyntheticsInjectRum = willSyntheticsInjectRum;
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
exports.getSyntheticsTestId = getSyntheticsTestId;
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
exports.getSyntheticsResultId = getSyntheticsResultId;

},{"../../browser/cookie":18}],38:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTelemetryConfiguration = exports.isTelemetryReplicationAllowed = exports.startTelemetry = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = void 0;
var telemetry_1 = require("./telemetry");
Object.defineProperty(exports, "addTelemetryDebug", { enumerable: true, get: function () { return telemetry_1.addTelemetryDebug; } });
Object.defineProperty(exports, "addTelemetryError", { enumerable: true, get: function () { return telemetry_1.addTelemetryError; } });
Object.defineProperty(exports, "startFakeTelemetry", { enumerable: true, get: function () { return telemetry_1.startFakeTelemetry; } });
Object.defineProperty(exports, "resetTelemetry", { enumerable: true, get: function () { return telemetry_1.resetTelemetry; } });
Object.defineProperty(exports, "startTelemetry", { enumerable: true, get: function () { return telemetry_1.startTelemetry; } });
Object.defineProperty(exports, "isTelemetryReplicationAllowed", { enumerable: true, get: function () { return telemetry_1.isTelemetryReplicationAllowed; } });
Object.defineProperty(exports, "addTelemetryConfiguration", { enumerable: true, get: function () { return telemetry_1.addTelemetryConfiguration; } });
__exportStar(require("./rawTelemetryEvent.types"), exports);
__exportStar(require("./telemetryEvent.types"), exports);

},{"./rawTelemetryEvent.types":39,"./telemetry":40,"./telemetryEvent.types":41}],39:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryType = void 0;
exports.TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};

},{}],40:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrubCustomerFrames = exports.formatError = exports.addTelemetryConfiguration = exports.addTelemetryError = exports.addTelemetryDebug = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.startTelemetry = void 0;
var display_1 = require("../../tools/display");
var error_1 = require("../../tools/error");
var utils_1 = require("../../tools/utils");
var configuration_1 = require("../configuration");
var tracekit_1 = require("../tracekit");
var observable_1 = require("../../tools/observable");
var timeUtils_1 = require("../../tools/timeUtils");
var monitor_1 = require("../../tools/monitor");
var rawTelemetryEvent_types_1 = require("./rawTelemetryEvent.types");
var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [configuration_1.INTAKE_SITE_US1_FED];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new observable_1.Observable();
    telemetryConfiguration.telemetryEnabled = (0, utils_1.performDraw)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0, utils_1.performDraw)(configuration.telemetryConfigurationSampleRate);
    onRawTelemetryEventCollected = function (event) {
        if (!(0, utils_1.includes)(TELEMETRY_EXCLUDED_SITES, configuration.site) && telemetryConfiguration.telemetryEnabled) {
            observable.notify(toTelemetryEvent(telemetryService, event));
        }
    };
    (0, monitor_1.startMonitorErrorCollection)(addTelemetryError);
    (0, utils_1.assign)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event) {
        return (0, utils_1.combine)({
            type: 'telemetry',
            date: (0, timeUtils_1.timeStampNow)(),
            service: telemetryService,
            version: "4.26.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: event,
            experimental_features: (0, utils_1.arrayFrom)((0, configuration_1.getExperimentalFeatures)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
    };
}
exports.startTelemetry = startTelemetry;
function startFakeTelemetry() {
    var events = [];
    (0, utils_1.assign)(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
exports.startFakeTelemetry = startFakeTelemetry;
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
exports.resetTelemetry = resetTelemetry;
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === configuration_1.INTAKE_SITE_STAGING;
}
exports.isTelemetryReplicationAllowed = isTelemetryReplicationAllowed;
function addTelemetryDebug(message, context) {
    (0, monitor_1.displayIfDebugEnabled)(display_1.ConsoleApiName.debug, message, context);
    addTelemetry((0, utils_1.assign)({
        type: rawTelemetryEvent_types_1.TelemetryType.log,
        message: message,
        status: "debug" /* debug */,
    }, context));
}
exports.addTelemetryDebug = addTelemetryDebug;
function addTelemetryError(e) {
    addTelemetry((0, utils_1.assign)({
        type: rawTelemetryEvent_types_1.TelemetryType.log,
        status: "error" /* error */,
    }, formatError(e)));
}
exports.addTelemetryError = addTelemetryError;
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: rawTelemetryEvent_types_1.TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
exports.addTelemetryConfiguration = addTelemetryConfiguration;
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0, tracekit_1.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, error_1.toStackTraceString)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught ".concat((0, utils_1.jsonStringify)(e)),
    };
}
exports.formatError = formatError;
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0, utils_1.startsWith)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
exports.scrubCustomerFrames = scrubCustomerFrames;

},{"../../tools/display":55,"../../tools/error":56,"../../tools/monitor":59,"../../tools/observable":60,"../../tools/timeUtils":62,"../../tools/utils":64,"../configuration":25,"../tracekit":43,"./rawTelemetryEvent.types":39}],41:[function(require,module,exports){
"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */
Object.defineProperty(exports, "__esModule", { value: true });

},{}],42:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeStackTrace = void 0;
var utils_1 = require("../../tools/utils");
var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0, utils_1.startsWith)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
exports.computeStackTrace = computeStackTrace;
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}

},{"../../tools/utils":64}],43:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUnhandledErrorCollection = exports.computeStackTrace = void 0;
var computeStackTrace_1 = require("./computeStackTrace");
Object.defineProperty(exports, "computeStackTrace", { enumerable: true, get: function () { return computeStackTrace_1.computeStackTrace; } });
var tracekit_1 = require("./tracekit");
Object.defineProperty(exports, "startUnhandledErrorCollection", { enumerable: true, get: function () { return tracekit_1.startUnhandledErrorCollection; } });

},{"./computeStackTrace":42,"./tracekit":44}],44:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUnhandledErrorCollection = void 0;
var instrumentMethod_1 = require("../../tools/instrumentMethod");
var computeStackTrace_1 = require("./computeStackTrace");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
exports.startUnhandledErrorCollection = startUnhandledErrorCollection;
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onerror', {
        before: function (message, url, lineNo, columnNo, errorObj) {
            var stack;
            if (errorObj) {
                stack = (0, computeStackTrace_1.computeStackTrace)(errorObj);
                callback(stack, errorObj);
            }
            else {
                var location_1 = {
                    url: url,
                    column: columnNo,
                    line: lineNo,
                };
                var name_1;
                var msg = message;
                if ({}.toString.call(message) === '[object String]') {
                    var groups = ERROR_TYPES_RE.exec(msg);
                    if (groups) {
                        name_1 = groups[1];
                        msg = groups[2];
                    }
                }
                stack = {
                    name: name_1,
                    message: typeof msg === 'string' ? msg : undefined,
                    stack: [location_1],
                };
                callback(stack, message);
            }
        },
    });
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = (0, computeStackTrace_1.computeStackTrace)(reason);
            callback(stack, reason);
        },
    });
}

},{"../../tools/instrumentMethod":57,"./computeStackTrace":42}],45:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./user.types"), exports);
__exportStar(require("./user"), exports);

},{"./user":46,"./user.types":47}],46:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkUser = exports.sanitizeUser = void 0;
var display_1 = require("../../tools/display");
var utils_1 = require("../../tools/utils");
/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0, utils_1.assign)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
exports.sanitizeUser = sanitizeUser;
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0, utils_1.getType)(newUser) === 'object';
    if (!isValid) {
        display_1.display.error('Unsupported user:', newUser);
    }
    return isValid;
}
exports.checkUser = checkUser;

},{"../../tools/display":55,"../../tools/utils":64}],47:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

},{}],48:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConsoleObservable = exports.createPageExitObservable = exports.initFetchObservable = exports.initXhrObservable = exports.COOKIE_ACCESS_DELAY = exports.deleteCookie = exports.setCookie = exports.getCookie = exports.areCookiesAuthorized = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.createHandlingStack = exports.computeRawError = exports.ErrorSource = exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.Batch = exports.createHttpRequest = exports.SESSION_TIME_OUT_DELAY = exports.stopSessionManager = exports.startSessionManager = exports.Observable = exports.setDebugMode = exports.callMonitored = exports.monitor = exports.monitored = exports.addTelemetryConfiguration = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = exports.startTelemetry = exports.RawReportType = exports.initReportObservable = exports.makePublicApi = exports.defineGlobal = exports.computeStackTrace = exports.trackRuntimeError = exports.serializeConfiguration = exports.resetExperimentalFeatures = exports.updateExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.DefaultPrivacyLevel = exports.validateAndBuildConfiguration = exports.buildCookieOptions = void 0;
exports.sanitizeUser = exports.checkUser = exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SESSION_COOKIE_NAME = exports.readBytesFromStream = exports.CLEAR_OLD_CONTEXTS_INTERVAL = exports.ContextHistory = exports.limitModification = exports.createContextManager = exports.catchUserErrors = exports.BoundedBuffer = void 0;
var configuration_1 = require("./domain/configuration");
Object.defineProperty(exports, "buildCookieOptions", { enumerable: true, get: function () { return configuration_1.buildCookieOptions; } });
Object.defineProperty(exports, "validateAndBuildConfiguration", { enumerable: true, get: function () { return configuration_1.validateAndBuildConfiguration; } });
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return configuration_1.DefaultPrivacyLevel; } });
Object.defineProperty(exports, "isExperimentalFeatureEnabled", { enumerable: true, get: function () { return configuration_1.isExperimentalFeatureEnabled; } });
Object.defineProperty(exports, "updateExperimentalFeatures", { enumerable: true, get: function () { return configuration_1.updateExperimentalFeatures; } });
Object.defineProperty(exports, "resetExperimentalFeatures", { enumerable: true, get: function () { return configuration_1.resetExperimentalFeatures; } });
Object.defineProperty(exports, "serializeConfiguration", { enumerable: true, get: function () { return configuration_1.serializeConfiguration; } });
var trackRuntimeError_1 = require("./domain/error/trackRuntimeError");
Object.defineProperty(exports, "trackRuntimeError", { enumerable: true, get: function () { return trackRuntimeError_1.trackRuntimeError; } });
var tracekit_1 = require("./domain/tracekit");
Object.defineProperty(exports, "computeStackTrace", { enumerable: true, get: function () { return tracekit_1.computeStackTrace; } });
var init_1 = require("./boot/init");
Object.defineProperty(exports, "defineGlobal", { enumerable: true, get: function () { return init_1.defineGlobal; } });
Object.defineProperty(exports, "makePublicApi", { enumerable: true, get: function () { return init_1.makePublicApi; } });
var reportObservable_1 = require("./domain/report/reportObservable");
Object.defineProperty(exports, "initReportObservable", { enumerable: true, get: function () { return reportObservable_1.initReportObservable; } });
Object.defineProperty(exports, "RawReportType", { enumerable: true, get: function () { return reportObservable_1.RawReportType; } });
var telemetry_1 = require("./domain/telemetry");
Object.defineProperty(exports, "startTelemetry", { enumerable: true, get: function () { return telemetry_1.startTelemetry; } });
Object.defineProperty(exports, "addTelemetryDebug", { enumerable: true, get: function () { return telemetry_1.addTelemetryDebug; } });
Object.defineProperty(exports, "addTelemetryError", { enumerable: true, get: function () { return telemetry_1.addTelemetryError; } });
Object.defineProperty(exports, "startFakeTelemetry", { enumerable: true, get: function () { return telemetry_1.startFakeTelemetry; } });
Object.defineProperty(exports, "resetTelemetry", { enumerable: true, get: function () { return telemetry_1.resetTelemetry; } });
Object.defineProperty(exports, "isTelemetryReplicationAllowed", { enumerable: true, get: function () { return telemetry_1.isTelemetryReplicationAllowed; } });
Object.defineProperty(exports, "addTelemetryConfiguration", { enumerable: true, get: function () { return telemetry_1.addTelemetryConfiguration; } });
var monitor_1 = require("./tools/monitor");
Object.defineProperty(exports, "monitored", { enumerable: true, get: function () { return monitor_1.monitored; } });
Object.defineProperty(exports, "monitor", { enumerable: true, get: function () { return monitor_1.monitor; } });
Object.defineProperty(exports, "callMonitored", { enumerable: true, get: function () { return monitor_1.callMonitored; } });
Object.defineProperty(exports, "setDebugMode", { enumerable: true, get: function () { return monitor_1.setDebugMode; } });
var observable_1 = require("./tools/observable");
Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return observable_1.Observable; } });
var sessionManager_1 = require("./domain/session/sessionManager");
Object.defineProperty(exports, "startSessionManager", { enumerable: true, get: function () { return sessionManager_1.startSessionManager; } });
// Exposed for tests
Object.defineProperty(exports, "stopSessionManager", { enumerable: true, get: function () { return sessionManager_1.stopSessionManager; } });
var sessionConstants_1 = require("./domain/session/sessionConstants");
Object.defineProperty(exports, "SESSION_TIME_OUT_DELAY", { enumerable: true, get: function () { return sessionConstants_1.SESSION_TIME_OUT_DELAY; } });
var transport_1 = require("./transport");
Object.defineProperty(exports, "createHttpRequest", { enumerable: true, get: function () { return transport_1.createHttpRequest; } });
Object.defineProperty(exports, "Batch", { enumerable: true, get: function () { return transport_1.Batch; } });
Object.defineProperty(exports, "canUseEventBridge", { enumerable: true, get: function () { return transport_1.canUseEventBridge; } });
Object.defineProperty(exports, "getEventBridge", { enumerable: true, get: function () { return transport_1.getEventBridge; } });
Object.defineProperty(exports, "startBatchWithReplica", { enumerable: true, get: function () { return transport_1.startBatchWithReplica; } });
__exportStar(require("./tools/display"), exports);
__exportStar(require("./tools/urlPolyfill"), exports);
__exportStar(require("./tools/timeUtils"), exports);
__exportStar(require("./tools/utils"), exports);
__exportStar(require("./tools/createEventRateLimiter"), exports);
__exportStar(require("./tools/browserDetection"), exports);
var instrumentMethod_1 = require("./tools/instrumentMethod");
Object.defineProperty(exports, "instrumentMethod", { enumerable: true, get: function () { return instrumentMethod_1.instrumentMethod; } });
Object.defineProperty(exports, "instrumentMethodAndCallOriginal", { enumerable: true, get: function () { return instrumentMethod_1.instrumentMethodAndCallOriginal; } });
Object.defineProperty(exports, "instrumentSetter", { enumerable: true, get: function () { return instrumentMethod_1.instrumentSetter; } });
var error_1 = require("./tools/error");
Object.defineProperty(exports, "ErrorSource", { enumerable: true, get: function () { return error_1.ErrorSource; } });
Object.defineProperty(exports, "computeRawError", { enumerable: true, get: function () { return error_1.computeRawError; } });
Object.defineProperty(exports, "createHandlingStack", { enumerable: true, get: function () { return error_1.createHandlingStack; } });
Object.defineProperty(exports, "toStackTraceString", { enumerable: true, get: function () { return error_1.toStackTraceString; } });
Object.defineProperty(exports, "getFileFromStackTraceString", { enumerable: true, get: function () { return error_1.getFileFromStackTraceString; } });
var cookie_1 = require("./browser/cookie");
Object.defineProperty(exports, "areCookiesAuthorized", { enumerable: true, get: function () { return cookie_1.areCookiesAuthorized; } });
Object.defineProperty(exports, "getCookie", { enumerable: true, get: function () { return cookie_1.getCookie; } });
Object.defineProperty(exports, "setCookie", { enumerable: true, get: function () { return cookie_1.setCookie; } });
Object.defineProperty(exports, "deleteCookie", { enumerable: true, get: function () { return cookie_1.deleteCookie; } });
Object.defineProperty(exports, "COOKIE_ACCESS_DELAY", { enumerable: true, get: function () { return cookie_1.COOKIE_ACCESS_DELAY; } });
var xhrObservable_1 = require("./browser/xhrObservable");
Object.defineProperty(exports, "initXhrObservable", { enumerable: true, get: function () { return xhrObservable_1.initXhrObservable; } });
var fetchObservable_1 = require("./browser/fetchObservable");
Object.defineProperty(exports, "initFetchObservable", { enumerable: true, get: function () { return fetchObservable_1.initFetchObservable; } });
var pageExitObservable_1 = require("./browser/pageExitObservable");
Object.defineProperty(exports, "createPageExitObservable", { enumerable: true, get: function () { return pageExitObservable_1.createPageExitObservable; } });
var consoleObservable_1 = require("./domain/console/consoleObservable");
Object.defineProperty(exports, "initConsoleObservable", { enumerable: true, get: function () { return consoleObservable_1.initConsoleObservable; } });
var boundedBuffer_1 = require("./tools/boundedBuffer");
Object.defineProperty(exports, "BoundedBuffer", { enumerable: true, get: function () { return boundedBuffer_1.BoundedBuffer; } });
var catchUserErrors_1 = require("./tools/catchUserErrors");
Object.defineProperty(exports, "catchUserErrors", { enumerable: true, get: function () { return catchUserErrors_1.catchUserErrors; } });
var contextManager_1 = require("./tools/contextManager");
Object.defineProperty(exports, "createContextManager", { enumerable: true, get: function () { return contextManager_1.createContextManager; } });
var limitModification_1 = require("./tools/limitModification");
Object.defineProperty(exports, "limitModification", { enumerable: true, get: function () { return limitModification_1.limitModification; } });
var contextHistory_1 = require("./tools/contextHistory");
Object.defineProperty(exports, "ContextHistory", { enumerable: true, get: function () { return contextHistory_1.ContextHistory; } });
Object.defineProperty(exports, "CLEAR_OLD_CONTEXTS_INTERVAL", { enumerable: true, get: function () { return contextHistory_1.CLEAR_OLD_CONTEXTS_INTERVAL; } });
var readBytesFromStream_1 = require("./tools/readBytesFromStream");
Object.defineProperty(exports, "readBytesFromStream", { enumerable: true, get: function () { return readBytesFromStream_1.readBytesFromStream; } });
var sessionCookieStore_1 = require("./domain/session/sessionCookieStore");
Object.defineProperty(exports, "SESSION_COOKIE_NAME", { enumerable: true, get: function () { return sessionCookieStore_1.SESSION_COOKIE_NAME; } });
var syntheticsWorkerValues_1 = require("./domain/synthetics/syntheticsWorkerValues");
Object.defineProperty(exports, "willSyntheticsInjectRum", { enumerable: true, get: function () { return syntheticsWorkerValues_1.willSyntheticsInjectRum; } });
Object.defineProperty(exports, "getSyntheticsTestId", { enumerable: true, get: function () { return syntheticsWorkerValues_1.getSyntheticsTestId; } });
Object.defineProperty(exports, "getSyntheticsResultId", { enumerable: true, get: function () { return syntheticsWorkerValues_1.getSyntheticsResultId; } });
var user_1 = require("./domain/user");
Object.defineProperty(exports, "checkUser", { enumerable: true, get: function () { return user_1.checkUser; } });
Object.defineProperty(exports, "sanitizeUser", { enumerable: true, get: function () { return user_1.sanitizeUser; } });

},{"./boot/init":17,"./browser/cookie":18,"./browser/fetchObservable":19,"./browser/pageExitObservable":20,"./browser/xhrObservable":21,"./domain/configuration":25,"./domain/console/consoleObservable":29,"./domain/error/trackRuntimeError":30,"./domain/report/reportObservable":31,"./domain/session/sessionConstants":33,"./domain/session/sessionCookieStore":34,"./domain/session/sessionManager":35,"./domain/synthetics/syntheticsWorkerValues":37,"./domain/telemetry":38,"./domain/tracekit":43,"./domain/user":45,"./tools/boundedBuffer":49,"./tools/browserDetection":50,"./tools/catchUserErrors":51,"./tools/contextHistory":52,"./tools/contextManager":53,"./tools/createEventRateLimiter":54,"./tools/display":55,"./tools/error":56,"./tools/instrumentMethod":57,"./tools/limitModification":58,"./tools/monitor":59,"./tools/observable":60,"./tools/readBytesFromStream":61,"./tools/timeUtils":62,"./tools/urlPolyfill":63,"./tools/utils":64,"./transport":68}],49:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundedBuffer = void 0;
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());
exports.BoundedBuffer = BoundedBuffer;

},{}],50:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChromium = exports.isIE = void 0;
function isIE() {
    return Boolean(document.documentMode);
}
exports.isIE = isIE;
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
exports.isChromium = isChromium;

},{}],51:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchUserErrors = void 0;
var display_1 = require("./display");
function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display_1.display.error(errorMsg, err);
        }
    };
}
exports.catchUserErrors = catchUserErrors;

},{"./display":55}],52:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextHistory = exports.CLEAR_OLD_CONTEXTS_INTERVAL = void 0;
var timeUtils_1 = require("./timeUtils");
var utils_1 = require("./utils");
var END_OF_TIMES = Infinity;
exports.CLEAR_OLD_CONTEXTS_INTERVAL = utils_1.ONE_MINUTE;
/**
 * Store and keep track of contexts spans. This whole class assumes that contexts are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ContextHistory = /** @class */ (function () {
    function ContextHistory(expireDelay) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.entries = [];
        this.clearOldContextsInterval = setInterval(function () { return _this.clearOldContexts(); }, exports.CLEAR_OLD_CONTEXTS_INTERVAL);
    }
    /**
     * Add a context to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ContextHistory.prototype.add = function (context, startTime) {
        var _this = this;
        var entry = {
            context: context,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest context that was active during `startTime`, or the currently active context
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ContextHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.context;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active context, if any. This method assumes that entries
     * are not overlapping.
     */
    ContextHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all contexts that were active during `startTime`, or all currently active contexts if no
     * `startTime` is provided.
     */
    ContextHistory.prototype.findAll = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        return this.entries
            .filter(function (entry) { return entry.startTime <= startTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.context; });
    };
    /**
     * Remove all entries from this collection.
     */
    ContextHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ContextHistory.prototype.stop = function () {
        clearInterval(this.clearOldContextsInterval);
    };
    ContextHistory.prototype.clearOldContexts = function () {
        var oldTimeThreshold = (0, timeUtils_1.relativeNow)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ContextHistory;
}());
exports.ContextHistory = ContextHistory;

},{"./timeUtils":62,"./utils":64}],53:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextManager = void 0;
var utils_1 = require("./utils");
function createContextManager() {
    var context = {};
    return {
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
        },
        getContext: function () { return (0, utils_1.deepClone)(context); },
        setContext: function (newContext) {
            context = (0, utils_1.deepClone)(newContext);
        },
        setContextProperty: function (key, property) {
            context[key] = (0, utils_1.deepClone)(property);
        },
        removeContextProperty: function (key) {
            delete context[key];
        },
        clearContext: function () {
            context = {};
        },
    };
}
exports.createContextManager = createContextManager;

},{"./utils":64}],54:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventRateLimiter = void 0;
var error_1 = require("./error");
var timeUtils_1 = require("./timeUtils");
var utils_1 = require("./utils");
function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                setTimeout(function () {
                    eventCount = 0;
                }, utils_1.ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: error_1.ErrorSource.AGENT,
                        startClocks: (0, timeUtils_1.clocksNow)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
exports.createEventRateLimiter = createEventRateLimiter;

},{"./error":56,"./timeUtils":62,"./utils":64}],55:[function(require,module,exports){
"use strict";
/* eslint-disable no-console, local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = exports.ConsoleApiName = void 0;
exports.ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var display = function (api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!Object.prototype.hasOwnProperty.call(exports.ConsoleApiName, api)) {
        api = exports.ConsoleApiName.log;
    }
    exports.display[api].apply(exports.display, args);
};
exports.display = display;
exports.display.debug = console.debug.bind(console);
exports.display.log = console.log.bind(console);
exports.display.info = console.info.bind(console);
exports.display.warn = console.warn.bind(console);
exports.display.error = console.error.bind(console);

},{}],56:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenErrorCauses = exports.createHandlingStack = exports.formatErrorMessage = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.computeRawError = exports.ErrorSource = void 0;
var tracekit_1 = require("../domain/tracekit");
var monitor_1 = require("./monitor");
var utils_1 = require("./utils");
exports.ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    if (!stackTrace || (stackTrace.message === undefined && !(originalError instanceof Error))) {
        return {
            startClocks: startClocks,
            source: source,
            handling: handling,
            originalError: originalError,
            message: "".concat(nonErrorPrefix, " ").concat((0, utils_1.jsonStringify)(originalError)),
            stack: 'No stack, consider using an instance of Error',
            handlingStack: handlingStack,
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        originalError: originalError,
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        handlingStack: handlingStack,
        type: stackTrace.name,
        causes: flattenErrorCauses(originalError, source),
    };
}
exports.computeRawError = computeRawError;
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
exports.toStackTraceString = toStackTraceString;
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
exports.getFileFromStackTraceString = getFileFromStackTraceString;
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
exports.formatErrorMessage = formatErrorMessage;
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0, utils_1.noop)();
        }
    }
    (0, monitor_1.callMonitored)(function () {
        var stackTrace = (0, tracekit_1.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
exports.createHandlingStack = createHandlingStack;
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0, tracekit_1.computeStackTrace)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
exports.flattenErrorCauses = flattenErrorCauses;

},{"../domain/tracekit":43,"./monitor":59,"./utils":64}],57:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = void 0;
var monitor_1 = require("./monitor");
var utils_1 = require("./utils");
function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
exports.instrumentMethod = instrumentMethod;
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                (0, monitor_1.callMonitored)(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                (0, monitor_1.callMonitored)(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
exports.instrumentMethodAndCallOriginal = instrumentMethodAndCallOriginal;
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: utils_1.noop };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        setTimeout((0, monitor_1.monitor)(function () {
            after(thisObject, value);
        }), 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = utils_1.noop;
            }
        },
    };
}
exports.instrumentSetter = instrumentSetter;

},{"./monitor":59,"./utils":64}],58:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitModification = void 0;
var utils_1 = require("./utils");
/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0, utils_1.deepClone)(object);
    var result = modifier(clone);
    modifiableFieldPaths.forEach(function (path) {
        var originalValue = get(object, path);
        var newValue = get(clone, path);
        var originalType = (0, utils_1.getType)(originalValue);
        var newType = (0, utils_1.getType)(newValue);
        if (newType === originalType) {
            set(object, path, newValue);
        }
        else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, path, {});
        }
    });
    return result;
}
exports.limitModification = limitModification;
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObjectContaining(object, field) {
    return typeof object === 'object' && object !== null && Object.prototype.hasOwnProperty.call(object, field);
}

},{"./utils":64}],59:[function(require,module,exports){
"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayIfDebugEnabled = exports.callMonitored = exports.monitor = exports.monitored = exports.resetMonitor = exports.setDebugMode = exports.startMonitorErrorCollection = void 0;
var display_1 = require("./display");
var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
exports.startMonitorErrorCollection = startMonitorErrorCollection;
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
exports.setDebugMode = setDebugMode;
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
exports.resetMonitor = resetMonitor;
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
exports.monitored = monitored;
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
exports.monitor = monitor;
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(display_1.ConsoleApiName.error, e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(display_1.ConsoleApiName.error, e);
            }
        }
    }
}
exports.callMonitored = callMonitored;
function displayIfDebugEnabled(api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugMode) {
        display_1.display.apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
    }
}
exports.displayIfDebugEnabled = displayIfDebugEnabled;

},{"./display":55}],60:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObservables = exports.Observable = void 0;
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());
exports.Observable = Observable;
function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
exports.mergeObservables = mergeObservables;

},{}],61:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readBytesFromStream = void 0;
var monitor_1 = require("./monitor");
var utils_1 = require("./utils");
/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0, monitor_1.monitor)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody)
                chunks.push(result.value);
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0, monitor_1.monitor)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        utils_1.noop);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
exports.readBytesFromStream = readBytesFromStream;

},{"./monitor":59,"./utils":64}],62:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetNavigationStart = exports.looksLikeRelativeTime = exports.getTimeStamp = exports.getRelativeTime = exports.addDuration = exports.elapsed = exports.clocksOrigin = exports.clocksNow = exports.relativeNow = exports.timeStampNow = exports.dateNow = exports.toServerDuration = exports.currentDrift = exports.relativeToClocks = void 0;
var utils_1 = require("./utils");
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
exports.relativeToClocks = relativeToClocks;
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
exports.currentDrift = currentDrift;
function toServerDuration(duration) {
    if (!(0, utils_1.isNumber)(duration)) {
        return duration;
    }
    return (0, utils_1.round)(duration * 1e6, 0);
}
exports.toServerDuration = toServerDuration;
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
exports.dateNow = dateNow;
function timeStampNow() {
    return dateNow();
}
exports.timeStampNow = timeStampNow;
function relativeNow() {
    return performance.now();
}
exports.relativeNow = relativeNow;
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
exports.clocksNow = clocksNow;
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
exports.clocksOrigin = clocksOrigin;
function elapsed(start, end) {
    return (end - start);
}
exports.elapsed = elapsed;
function addDuration(a, b) {
    return a + b;
}
exports.addDuration = addDuration;
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
exports.getRelativeTime = getRelativeTime;
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
exports.getTimeStamp = getTimeStamp;
function looksLikeRelativeTime(time) {
    return time < utils_1.ONE_YEAR;
}
exports.looksLikeRelativeTime = looksLikeRelativeTime;
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
exports.resetNavigationStart = resetNavigationStart;

},{"./utils":64}],63:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = exports.getHash = exports.getSearch = exports.getPathName = exports.getOrigin = exports.haveSameOrigin = exports.isValidUrl = exports.normalizeUrl = void 0;
var utils_1 = require("./utils");
function normalizeUrl(url) {
    return buildUrl(url, (0, utils_1.getLocationOrigin)()).href;
}
exports.normalizeUrl = normalizeUrl;
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
exports.isValidUrl = isValidUrl;
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
exports.haveSameOrigin = haveSameOrigin;
function getOrigin(url) {
    return (0, utils_1.getLinkElementOrigin)(buildUrl(url));
}
exports.getOrigin = getOrigin;
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
exports.getPathName = getPathName;
function getSearch(url) {
    return buildUrl(url).search;
}
exports.getSearch = getSearch;
function getHash(url) {
    return buildUrl(url).hash;
}
exports.getHash = getHash;
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
exports.buildUrl = buildUrl;
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}

},{"./utils":64}],64:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssEscape = exports.matchList = exports.removeDuplicates = exports.requestIdleCallback = exports.combine = exports.deepClone = exports.mergeInto = exports.getType = exports.runOnReadyState = exports.elementMatches = exports.addEventListeners = exports.addEventListener = exports.safeTruncate = exports.findCommaSeparatedValue = exports.getLinkElementOrigin = exports.getLocationOrigin = exports.getGlobalObject = exports.endsWith = exports.startsWith = exports.mapValues = exports.isEmptyObject = exports.objectEntries = exports.objectHasValue = exports.objectValues = exports.isNumber = exports.isPercentage = exports.findLast = exports.find = exports.arrayFrom = exports.includes = exports.jsonStringify = exports.noop = exports.round = exports.performDraw = exports.generateUUID = exports.shallowClone = exports.assign = exports.throttle = exports.ONE_MEBI_BYTE = exports.ONE_KIBI_BYTE = exports.ONE_YEAR = exports.ONE_DAY = exports.ONE_HOUR = exports.ONE_MINUTE = exports.ONE_SECOND = void 0;
var display_1 = require("./display");
var monitor_1 = require("./monitor");
exports.ONE_SECOND = 1000;
exports.ONE_MINUTE = 60 * exports.ONE_SECOND;
exports.ONE_HOUR = 60 * exports.ONE_MINUTE;
exports.ONE_DAY = 24 * exports.ONE_HOUR;
exports.ONE_YEAR = 365 * exports.ONE_DAY;
exports.ONE_KIBI_BYTE = 1024;
exports.ONE_MEBI_BYTE = 1024 * exports.ONE_KIBI_BYTE;
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
exports.throttle = throttle;
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
exports.assign = assign;
function shallowClone(object) {
    return assign({}, object);
}
exports.shallowClone = shallowClone;
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
exports.generateUUID = generateUUID;
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
exports.performDraw = performDraw;
function round(num, decimals) {
    return +num.toFixed(decimals);
}
exports.round = round;
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
exports.noop = noop;
/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
exports.jsonStringify = jsonStringify;
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return noop;
}
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
exports.includes = includes;
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
exports.arrayFrom = arrayFrom;
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
exports.find = find;
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
exports.findLast = findLast;
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
exports.isPercentage = isPercentage;
function isNumber(value) {
    return typeof value === 'number';
}
exports.isNumber = isNumber;
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
exports.objectValues = objectValues;
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
exports.objectHasValue = objectHasValue;
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
exports.objectEntries = objectEntries;
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
exports.isEmptyObject = isEmptyObject;
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
exports.mapValues = mapValues;
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
exports.startsWith = startsWith;
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
exports.endsWith = endsWith;
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
exports.getGlobalObject = getGlobalObject;
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
exports.getLocationOrigin = getLocationOrigin;
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
exports.getLinkElementOrigin = getLinkElementOrigin;
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
exports.findCommaSeparatedValue = findCommaSeparatedValue;
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength)
        return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
exports.safeTruncate = safeTruncate;
/**
 * Add an event listener to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(emitter, event, listener, options) {
    return addEventListeners(emitter, [event], listener, options);
}
exports.addEventListener = addEventListener;
/**
 * Add event listeners to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(emitter, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = (0, monitor_1.monitor)(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    events.forEach(function (event) { return emitter.addEventListener(event, wrappedListener, options); });
    var stop = function () { return events.forEach(function (event) { return emitter.removeEventListener(event, wrappedListener, options); }); };
    return {
        stop: stop,
    };
}
exports.addEventListeners = addEventListeners;
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
exports.elementMatches = elementMatches;
function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        addEventListener(window, eventName, callback, { once: true });
    }
}
exports.runOnReadyState = runOnReadyState;
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
exports.getType = getType;
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
exports.mergeInto = mergeInto;
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
exports.deepClone = deepClone;
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
exports.combine = combine;
function requestIdleCallback(callback, opts) {
    // Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
    // browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
    // fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
    // browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes
    // efficiently.
    if (window.requestIdleCallback) {
        var id_1 = window.requestIdleCallback((0, monitor_1.monitor)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0, monitor_1.monitor)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
exports.requestIdleCallback = requestIdleCallback;
function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return arrayFrom(set);
}
exports.removeDuplicates = removeDuplicates;
function matchList(list, value) {
    return list.some(function (item) {
        if (typeof item === 'function') {
            try {
                return item(value);
            }
            catch (e) {
                display_1.display.error(e);
                return false;
            }
        }
        if (item instanceof RegExp) {
            return item.test(value);
        }
        return item === value;
    });
}
exports.matchList = matchList;
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
exports.cssEscape = cssEscape;

},{"./display":55,"./monitor":59}],65:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batch = void 0;
var display_1 = require("../tools/display");
var utils_1 = require("../tools/utils");
var monitor_1 = require("../tools/monitor");
// https://en.wikipedia.org/wiki/UTF-8
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
var Batch = /** @class */ (function () {
    function Batch(request, batchMessagesLimit, batchBytesLimit, messageBytesLimit, flushTimeout, pageExitObservable) {
        var _this = this;
        this.request = request;
        this.batchMessagesLimit = batchMessagesLimit;
        this.batchBytesLimit = batchBytesLimit;
        this.messageBytesLimit = messageBytesLimit;
        this.flushTimeout = flushTimeout;
        this.pageExitObservable = pageExitObservable;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesCount = 0;
        this.bufferMessagesCount = 0;
        pageExitObservable.subscribe(function () { return _this.flush(_this.request.sendOnExit); });
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (sendFn) {
        if (sendFn === void 0) { sendFn = this.request.send; }
        if (this.bufferMessagesCount !== 0) {
            var messages = this.pushOnlyBuffer.concat((0, utils_1.objectValues)(this.upsertBuffer));
            var bytesCount = this.bufferBytesCount;
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesCount = 0;
            this.bufferMessagesCount = 0;
            sendFn({ data: messages.join('\n'), bytesCount: bytesCount });
        }
    };
    Batch.prototype.computeBytesCount = function (candidate) {
        // Accurate bytes count computations can degrade performances when there is a lot of events to process
        if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
            return candidate.length;
        }
        if (window.TextEncoder !== undefined) {
            return new TextEncoder().encode(candidate).length;
        }
        return new Blob([candidate]).size;
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            display_1.display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesCount)) {
            this.flush();
        }
        this.push(processedMessage, messageBytesCount, key);
        if (this.isFull()) {
            this.flush();
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = (0, utils_1.jsonStringify)(message);
        var messageBytesCount = this.computeBytesCount(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        if (this.bufferMessagesCount > 0) {
            // \n separator at serialization
            this.bufferBytesCount += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesCount += messageBytesCount;
        this.bufferMessagesCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = this.computeBytesCount(removedMessage);
        this.bufferBytesCount -= messageBytesCount;
        this.bufferMessagesCount -= 1;
        if (this.bufferMessagesCount > 0) {
            this.bufferBytesCount -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesCount) {
        // byte of the separator at the end of the message
        return this.bufferBytesCount + messageBytesCount + 1 >= this.batchBytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessagesCount === this.batchMessagesLimit || this.bufferBytesCount >= this.batchBytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        setTimeout((0, monitor_1.monitor)(function () {
            _this.flush();
            _this.flushPeriodically();
        }), this.flushTimeout);
    };
    return Batch;
}());
exports.Batch = Batch;

},{"../tools/display":55,"../tools/monitor":59,"../tools/utils":64}],66:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseEventBridge = exports.getEventBridge = void 0;
var utils_1 = require("../tools/utils");
function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
exports.getEventBridge = getEventBridge;
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0, utils_1.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0, utils_1.endsWith)(currentHost, ".".concat(allowedHost)); }));
}
exports.canUseEventBridge = canUseEventBridge;
function getEventBridgeGlobal() {
    return (0, utils_1.getGlobalObject)().DatadogEventBridge;
}

},{"../tools/utils":64}],67:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendXHR = exports.fetchKeepAliveStrategy = exports.createHttpRequest = void 0;
var telemetry_1 = require("../domain/telemetry");
var monitor_1 = require("../tools/monitor");
var sendWithRetryStrategy_1 = require("./sendWithRetryStrategy");
function createHttpRequest(endpointBuilder, bytesLimit, reportError) {
    var retryState = (0, sendWithRetryStrategy_1.newRetryState)();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            (0, sendWithRetryStrategy_1.sendWithRetryStrategy)(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        },
    };
}
exports.createHttpRequest = createHttpRequest;
function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
    var data = _a.data, bytesCount = _a.bytesCount;
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon');
            var isQueued = navigator.sendBeacon(beaconUrl, data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr');
    sendXHR(xhrUrl, data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0, telemetry_1.addTelemetryError)(e);
    }
}
function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
    var data = _a.data, bytesCount = _a.bytesCount, retry = _a.retry;
    var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', retry);
        fetch(fetchUrl, { method: 'POST', body: data, keepalive: true }).then((0, monitor_1.monitor)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status }); }), (0, monitor_1.monitor)(function () {
            var xhrUrl = endpointBuilder.build('xhr', retry);
            // failed to queue the request
            sendXHR(xhrUrl, data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', retry);
        sendXHR(xhrUrl, data, onResponse);
    }
}
exports.fetchKeepAliveStrategy = fetchKeepAliveStrategy;
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(url, data, onResponse) {
    var request = new XMLHttpRequest();
    var onLoadEnd = (0, monitor_1.monitor)(function () {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        request.removeEventListener('loadend', onLoadEnd);
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    });
    request.open('POST', url, true);
    request.addEventListener('loadend', onLoadEnd);
    request.send(data);
}
exports.sendXHR = sendXHR;

},{"../domain/telemetry":38,"../tools/monitor":59,"./sendWithRetryStrategy":69}],68:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.Batch = exports.createHttpRequest = void 0;
var httpRequest_1 = require("./httpRequest");
Object.defineProperty(exports, "createHttpRequest", { enumerable: true, get: function () { return httpRequest_1.createHttpRequest; } });
var batch_1 = require("./batch");
Object.defineProperty(exports, "Batch", { enumerable: true, get: function () { return batch_1.Batch; } });
var eventBridge_1 = require("./eventBridge");
Object.defineProperty(exports, "canUseEventBridge", { enumerable: true, get: function () { return eventBridge_1.canUseEventBridge; } });
Object.defineProperty(exports, "getEventBridge", { enumerable: true, get: function () { return eventBridge_1.getEventBridge; } });
var startBatchWithReplica_1 = require("./startBatchWithReplica");
Object.defineProperty(exports, "startBatchWithReplica", { enumerable: true, get: function () { return startBatchWithReplica_1.startBatchWithReplica; } });

},{"./batch":65,"./eventBridge":66,"./httpRequest":67,"./startBatchWithReplica":70}],69:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRetryState = exports.sendWithRetryStrategy = exports.INITIAL_BACKOFF_TIME = exports.MAX_BACKOFF_TIME = exports.MAX_QUEUE_BYTES_COUNT = exports.MAX_ONGOING_REQUESTS = exports.MAX_ONGOING_BYTES_COUNT = void 0;
var monitor_1 = require("../tools/monitor");
var timeUtils_1 = require("../tools/timeUtils");
var utils_1 = require("../tools/utils");
var error_1 = require("../tools/error");
exports.MAX_ONGOING_BYTES_COUNT = 80 * utils_1.ONE_KIBI_BYTE;
exports.MAX_ONGOING_REQUESTS = 32;
exports.MAX_QUEUE_BYTES_COUNT = 3 * utils_1.ONE_MEBI_BYTE;
exports.MAX_BACKOFF_TIME = utils_1.ONE_MINUTE;
exports.INITIAL_BACKOFF_TIME = utils_1.ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
exports.sendWithRetryStrategy = sendWithRetryStrategy;
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* DOWN */) {
        return;
    }
    setTimeout((0, monitor_1.monitor)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = exports.INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(exports.MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }), state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* FAILURE_DETECTED */ : 2 /* DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(exports.MAX_QUEUE_BYTES_COUNT / utils_1.ONE_MEBI_BYTE, "MiB"),
            source: error_1.ErrorSource.AGENT,
            startClocks: (0, timeUtils_1.clocksNow)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return response.status === 0 || response.status === 408 || response.status === 429 || response.status >= 500;
}
function newRetryState() {
    return {
        transportStatus: 0 /* UP */,
        currentBackoffTime: exports.INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
exports.newRetryState = newRetryState;
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= exports.MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= exports.MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < exports.MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}

},{"../tools/error":56,"../tools/monitor":59,"../tools/timeUtils":62,"../tools/utils":64}],70:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startBatchWithReplica = void 0;
var batch_1 = require("./batch");
var httpRequest_1 = require("./httpRequest");
function startBatchWithReplica(configuration, endpoint, reportError, pageExitObservable, replicaEndpoint) {
    var primaryBatch = createBatch(endpoint);
    var replicaBatch;
    if (replicaEndpoint) {
        replicaBatch = createBatch(replicaEndpoint);
    }
    function createBatch(endpointBuilder) {
        return new batch_1.Batch((0, httpRequest_1.createHttpRequest)(endpointBuilder, configuration.batchBytesLimit, reportError), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, pageExitObservable);
    }
    return {
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(message);
            }
        },
    };
}
exports.startBatchWithReplica = startBatchWithReplica;

},{"./batch":65,"./httpRequest":67}],71:[function(require,module,exports){
'use strict';

var _browserLogs = require('@datadog/browser-logs');

//環境取得
var getEnv = function getEnv() {
  switch (location.hostname) {
    case 'app.pranalyzer.jp':
      return 'prd';
    case 'app-astg.pranalyzer.jp':
      return 'stg';
    case 'app-adev.pranalyzer.jp':
      return 'dev';
    default:
      return 'local';
  }
};

//datadog logs開始
var logInit = function logInit(env) {
  _browserLogs.datadogLogs.init({
    clientToken: 'pub4d803ac3bccc3c3afdaca0e96101563d',
    site: 'datadoghq.com',
    env: env,
    service: 'pra-www-front-' + env,
    forwardErrorsToLogs: true,
    sampleRate: 100
  });
};

var env = getEnv();

var logsTargetEnv = ['prd', 'stg', 'dev'];

if (logsTargetEnv.indexOf(env) !== -1) {
  logInit(env);
} else {
  console.info('datadog logs not fired');
}

},{"@datadog/browser-logs":14}]},{},[71]);
